import { useEffect } from 'react';

// Observes every .reveal descendant of `containerRef` once on mount (original
// portfolio.html pattern: threshold 0.15, reveal once, unobserve; no-IO fallback
// reveals immediately). The marker is a data attribute, NOT a class: React
// rewrites className wholesale when a component's state changes (e.g. CaseCard
// toggling .expanded), which silently wiped an imperatively-added class and
// faded the whole tile back to the .reveal hidden state — permanently, since
// the observer is one-shot. data-* attributes survive React's className diff.
export function useRevealAll(containerRef, deps = []) {
  useEffect(() => {
    const root = containerRef.current;
    if (!root) return undefined;
    const targets = root.querySelectorAll('.reveal:not([data-revealed])');
    if (!('IntersectionObserver' in window)) {
      targets.forEach((el) => el.setAttribute('data-revealed', ''));
      return undefined;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-revealed', '');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 },
    );
    targets.forEach((el) => io.observe(el));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
